import { ArrowUpRight, GraduationCap, BookOpen, Flower2 } from 'lucide-react';
import { assetUrl } from '@/lib/assetUrl';

export default function DoctorSection() {
  return (
    <section className="doctor-section clinic-section" id="medico" aria-labelledby="doctor-title">
      <div className="clinic-container doctor-layout">
        <div className="doctor-portrait">
          <img src={assetUrl('/images/dr-aderson-rocha.png')} alt="Dr. Aderson Moreira da Rocha Neto" loading="lazy" width="1254" height="1254" />
          <div className="doctor-photo-label"><Flower2 size={22}/><span>Medicina, pesquisa e tradição</span></div>
        </div>
        <div className="doctor-copy">
          <p className="eyebrow">CONHEÇA O MÉDICO</p>
          <h2 id="doctor-title">Dr. Aderson Moreira<br/>da Rocha Neto</h2>
          <p className="doctor-registration">Médico · CRM-RJ 52.53762-6</p>
          <p>Formado em Medicina pela UNIRIO em 1990, Aderson reúne em sua trajetória a prática clínica, a pesquisa e o estudo das tradições médicas orientais.</p>
          <p>É mestre e doutor em Saúde Coletiva pela UERJ, com pesquisa sobre o Ayurveda e estágio na Gujarat Ayurved University, na Índia. Sua formação inclui pós-graduações em Medicina de Família e Reumatologia pela UNIRIO e estudos de Ayurveda no Brasil e na Índia.</p>
          <div className="doctor-highlights">
            <div><GraduationCap size={23}/><span><strong>Formação e pesquisa</strong>Medicina pela UNIRIO e Saúde Coletiva pela UERJ.</span></div>
            <div><BookOpen size={23}/><span><strong>Autor de “A Tradição do Ayurveda”</strong>Livro publicado pela editora Águia Dourada a partir de sua pesquisa de doutorado.</span></div>
          </div>
          <p>Na Clínica de Ayurveda, no Rio de Janeiro, seu trabalho aproxima os conhecimentos da medicina ocidental e da tradição oriental em uma abordagem integrativa.</p>
          <a className="clinic-button" href="https://wa.me/5521982722070" target="_blank" rel="noopener noreferrer">Fale com a clínica <ArrowUpRight size={17}/></a>
          <p className="doctor-source">Conheça a <a href="https://ayurveda.com.br/sobre/" target="_blank" rel="noopener noreferrer">trajetória completa no perfil oficial da clínica</a>.</p>
        </div>
      </div>
    </section>
  );
}
